export default "__VITE_ASSET__Ckdi4wNR__"